import React from 'react';
import { SimplifiedTable } from 'features/command-center/components/shared';
import { OVERALL_PERFORMANCE_COLUMNS, TABLES_KEYS } from 'features/command-center/constants';
import { SECONDARY_API_CLIENT } from 'services/API';
import {
  ScrollableDataTable,
  ScrollableDataTableLayout
} from 'UI/components/templates/ScrollableDataTableLayout';

import { ORDER_BY_OPTIONS } from './HealthDistributionDrawerContent.constants';
import { formatResponse, generateFinalEndpoint } from './HealthDistributionDrawerContent.utils';

export const HealthDistributionDrawerContent = ({ endpoint = '' }) => {
  const finalEndpoint = generateFinalEndpoint(endpoint);

  return (
    <ScrollableDataTableLayout
      content={
        <SimplifiedTable
          apiInstance={SECONDARY_API_CLIENT}
          columns={OVERALL_PERFORMANCE_COLUMNS}
          endpoint={finalEndpoint}
          formatResponse={formatResponse}
          orderByOptions={ORDER_BY_OPTIONS}
          pageKey={TABLES_KEYS.healthDistributionStats}
          shouldUseSavedPagination={false}
          TableComponent={ScrollableDataTable}
          showWrapper={false}
        />
      }
    />
  );
};
